var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCreditCardPrimaryLightFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8CBAC7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.86 7.018v-.791c0-.903-.77-1.643-1.735-1.643H3.772c-.953 0-1.735.73-1.735 1.643v.791c0 .081.064.142.15.142H17.7c.086 0 .16-.06.16-.142zM2.037 8.411v5.152c0 .93.77 1.693 1.734 1.693h12.355c.953 0 1.735-.752 1.735-1.693V8.411a.145.145 0 0 0-.15-.146H2.187c-.086-.01-.15.063-.15.146zm3.95 3.95c0 .262-.224.481-.492.481h-.493a.492.492 0 0 1-.492-.48v-.481c0-.262.225-.481.492-.481h.493c.268 0 .492.22.492.48v.481z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCreditCardPrimaryLightFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-credit-card-primary-light-filled.f15d6056c13a26bd9ef48e371788b4de.svg";